(function() {
    angular.module('tmx-app').factory('ProductRateDetailService', ['tmxResource',
        function(tmxResource) {
            var ProductRateDetail = tmxResource("ProductRateDetail");

            ProductRateDetail.gridColumn = [
                {
                    field: "CreatedDate",
                    title: "CreatedDate",
                    type: "text",
                    template: "<md-button class='tmx-primary-text' ng-click='RateUploadCtrl.clickEdit(dataItem)' ng-bind='dataItem.CreatedDate'></md-button>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : RateUploadCtrl.isFiltered('CreatedDate')}\" >{{'CreatedDate' | translate}}<i class='fa fa-filter' ng-if='RateUploadCtrl.isFiltered(\"CreatedDate\")' ></i></span>"
                },
                {
                    field: "CreatedBy",
                    title: "CreatedBy",
                    type: "text",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : RateUploadCtrl.isFiltered('CreatedBy')}\" >{{'CreatedBy' | translate}}<i class='fa fa-filter' ng-if='RateUploadCtrl.isFiltered(\"CreatedBy\")' ></i></span>"
                }
            ];

            ProductRateDetail.columns = angular.copy(ProductRateDetail.gridColumn);

            return ProductRateDetail;
        }]);
})();
